import { PowerGenerationSourceEnum } from '@bo-client/activation-management/grid-registration/model/grid-registration.enum';

export enum ChronoUnitEnum {
  DAYS = 'DAYS',
  WEEKS = 'WEEKS',
  MONTHS = 'MONTHS'
}

export const ChronoUnitConst: any[] = [
  {
    value: ChronoUnitEnum.DAYS,
    displayName: 'Tage'
  },
  {
    value: ChronoUnitEnum.WEEKS,
    displayName: 'Woche'
  },
  {
    value: ChronoUnitEnum.MONTHS,
    displayName: 'Monate'
  }
];

export enum DocumentTagEnum {
  commissioningDoc = 'commissioningDoc',
  gridRegistrationDoc = 'gridRegistrationDoc',
  consumptionUnder30kw = 'consumptionUnder30kw'
}

export enum CompareEnum {
  greater = 'greater',
  less = 'less',
  equal = 'equal',
  notEqual = 'notEqual'
}

export enum ActionsTypeEnum {
  save = 'save',
  create = 'create',
  cancel = 'cancel',
  delete = 'delete',
  error = 'error'
}

export enum PaymentTypeEnum {
  DIRECTDEBIT = 'DIRECTDEBIT',
  BANKTRANSFER = 'BANKTRANSFER'
}
export const PaymentTypeDisplayName = {
  [PaymentTypeEnum.DIRECTDEBIT]: 'SEPA-Lastschriftmandat',
  [PaymentTypeEnum.BANKTRANSFER]: 'Überweisung'
};

export enum UserDecisionEnum {
  YES = 'YES',
  NO = 'NO',
  UNKNOWN = 'UNKNOWN'
}

export const UserDecisionDisplayName = {
  [UserDecisionEnum.YES]: 'Ja',
  [UserDecisionEnum.NO]: 'Nein',
  [UserDecisionEnum.UNKNOWN]: 'Weiß ich nicht'
};

export enum FieldConfigEnum {
  HIDDEN = 'HIDDEN',
  VISIBLE = 'VISIBLE',
  REQUIRED = 'REQUIRED'
}

export const FieldConfigDisplayName = {
  [FieldConfigEnum.HIDDEN]: 'Deaktivieren',
  [FieldConfigEnum.VISIBLE]: 'Anzeigen',
  [FieldConfigEnum.REQUIRED]: 'Erforderlich'
};
